/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2020-11-11 19:24:16
 */

import React, { Component } from "react";
import Preparation from "../components/preparation/preparation";
import { DataService } from "../services/data.service";
import { withRouter } from "react-router-dom";

import LocationImg from "../assets/images/location.png";
import LocationDarkImg from "../assets/images/location-white.png";
import CalendarImg from "../assets/images/calender_org.png";
import CalendarImgBlack from "../assets/images/calender_gry.png";
import Journey from "../components/journey/journey";
import swal from "sweetalert";
import moment from "moment";
import $ from "jquery";

import * as handler from "../components/utils/handler";
import RefreshButton from "./../components/utils/refreshButton";
import DangerButton from "../components/utils/dangerButton";
import IconButton from "../components/utils/iconButton";

import socketIoClient from "socket.io-client";
const ENDPOINT = "localhost:4001";

const queryString = require("query-string");

class ConfirmedAppointment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      branchAddress:
        this.props.getData().response.data.previous_appointment_info !==
          undefined &&
        this.props.getData().response.data.previous_appointment_info !== null
          ? this.props.getData().response.data.previous_appointment_info.address
          : this.props.getData().singleBranchDetails.length > 0
          ? this.props.getData().singleBranchDetails[0].Address
          : this.props.getData().selectedBranchFromMap !== null
          ? this.props.getData().selectedBranchFromMap.Address
          : null,

      branchTitle:
        this.props.getData().response.data.previous_appointment_info !==
          undefined &&
        this.props.getData().response.data.previous_appointment_info !== null
          ? this.props.getData().response.data.previous_appointment_info
              .branch_title
          : this.props.getData().singleBranchDetails.length > 0
          ? this.props.getData().singleBranchDetails[0].BranchTitle
          : this.props.getData().selectedBranchFromMap !== null
          ? this.props.getData().selectedBranchFromMap.BranchTitle
          : null,
      response: this.props.getData().response,
      whatsappUrl: window["app-config"].whatsappUrl,
      isTicketCalled: false,
      randomNumber: "",
    };
  }
  URL = window["app-config"].URL;
  runApp = window["app-config"].runApp;
  enableCategorySelection = window["app-config"].enableCategorySelection;
  userDetailsConfig = window["app-config"].userDetails;
  showGreetings = window["app-config"].ui.showGreetings;
  color = window["app-config"].ui.confirmScreen;
  icons = window["app-config"].ui.icons;
  defaultLanguage = window["app-config"].defaultLang;
  refreshInterval = window["app-config"].applicationProperties.refreshInterval;
  notificationSound = window["app-config"].notificationSound;
  popupExpiry = window["app-config"].ui.popupExpiry;
  dataService = new DataService();

  cancelButtonText = "";
  rescheduleButtonText = "";
  DoYouWantToRescheduleOrCancel = "";
  Attention = "";
  AppointmentAlreadyCanceled = "";
  AppointmentInfoNoValidToCancel = "";
  AlreadyServed = "";
  someThingWentWrong = "";
  error = "";
  For = "";
  Ok = "";
  CantCancelApptTcktIssued = "";
  AppointmentExpired = "";
  AppointmentCanceledAutomatically = "";
  Yes = "";
  No = "";
  TicketIssuedOn = "";
  WaitTime = "";
  Where = "";
  TotalWaitingTickets = "";
  CancelTicketConfirmation = "";
  UrlNotFound = "";
  InternetConnectionError = "";
  TicketNumber = "";
  BookingRef = "";
  Name = "";
  Email = "";
  PhoneNumber = "";
  NoOfPeople = "";
  WaitTimeMsg = "";
  Greetings = "";
  ServerNotResponding = "";
  TicketNotFound = "";

  componentDidMount() {
    this.generateUrl();
    handler.blinkText(".blink");

    if (
      this.props.getData().issueTicket ||
      this.props.getData().issueQrTicket
    ) {
      localStorage.setItem("confirmed", true);
      localStorage.setItem("confirmedDate", moment().toDate().toDateString());
      localStorage.setItem("prevState", JSON.stringify(this.props.getData()));
    }

    let lang;
    if (localStorage.getItem("lang") === "es") {
      lang = window["localization"].es;
    } else if (localStorage.getItem("lang") === "ar") {
      lang = window["localization"].ar;
    } else if (localStorage.getItem("lang") === "en") {
      lang = window["localization"].en;
    } else if (localStorage.getItem("lang") === "ur") {
      lang = window["localization"].ur;
    } else {
      let defaultLang = this.defaultLanguage;
      lang = window["localization"][defaultLang];
    }

    this.props.hideBtnBack();

    this.props.setHeading(
      this.props.getData().issueTicket === true ||
        this.props.getData().issueQrTicket === true
        ? lang.YourTicketHasBeenIssued
        : lang.YourAppointmentIsBooked
    );

    if (
      this.props.getData().issueTicket === true ||
      this.props.getData().issueQrTicket === true
    ) {
      // const socket = socketIoClient(ENDPOINT);
      // socket.on("getTicketStatus", (data) => {
      //   console.log("SOCKET CALLED: ", data);
      //   this.getTicketStatus();
      // });
      setInterval(() => {
        this.getTicketStatus();
      }, this.refreshInterval);

      handler.onBrowserReload(this.getTicketStatus);
    }
  }

  generateUrl = () => {
    if (
      this.props.getData().issueTicket &&
      this.state.response.data.ticket_info !== undefined &&
      this.state.response.data.ticket_info !== null
    ) {
      let branchCode =
        this.props.getData().singleBranchDetails.length > 0
          ? this.props.getData().singleBranchDetails[0].BranchCode
          : this.props.getData().selectedBranchFromMap.BranchCode;

      let ticketId = this.state.response.data.ticket_info.ticket_id;
      let whatsappUrl = `${this.URL.whatsappUrl}&text=${branchCode}%20${ticketId}`;
      this.setState({ whatsappUrl: whatsappUrl });
    } else if (this.props.getData().issueQrTicket) {
      let branchCode = queryString.parse(window.location.search).branchCode;
      let ticketId = this.state.response.data.ticket_id;
      let whatsappUrl = `${this.URL.whatsappUrl}&text=${branchCode}%20${ticketId}`;
      this.setState({ whatsappUrl: whatsappUrl });
    }
  };

  getGreetings = () => {
    if (
      this.props.getData().firstName !== null &&
      this.props.getData().firstName !== ""
    ) {
      return (
        <div className="booking-summary-wait sameTextColor">
          <h2
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor, padding: "30px" }}
          >
            {`${this.Greetings} ${
              this.props.getData().firstName !== undefined ||
              this.props.getData().firstName !== null
                ? this.props.getData().firstName
                : ""
            }`}
          </h2>
        </div>
      );
    }
  };

  getEstimatedWaitTimeMessage = () => {
    if (
      this.state.response.data !== undefined &&
      this.state.response.data !== null &&
      this.state.response.data !== "" &&
      this.props.getData().issueQrTicket === true
    ) {
      return (
        <div className="booking-summary-date" style={{ alignItems: "center" }}>
          <div>
            <p
              className="sameFont "
              style={{ whiteSpace: "pre-line", display: "block" }}
            >
              {`${this.state.response.MessageText}`}
            </p>
          </div>
          <br />
        </div>
      );
    }
  };

  getUserDetails = () => {
    if (this.props.getData().issueQrTicket === true) {
      return (
        <div className="booking-summary-wait">
          <strong
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.userDetailsConfig.enableFirstNameField === true
              ? this.Name
              : null}
          </strong>
          <p className="sameFont">{this.props.getData().firstName}</p>

          <br />
          <strong
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.userDetailsConfig.enableEmailField === true
              ? this.Email
              : null}
          </strong>
          <p className="sameFont">{this.props.getData().emailAddress}</p>

          <br />
          <strong
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.userDetailsConfig.enablePhoneNumberField === true
              ? this.PhoneNumber
              : null}
          </strong>
          <p className="sameFont">{this.props.getData().phoneNumber}</p>
          <br />
          <strong
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.userDetailsConfig.enableNoOfPeopleField === true
              ? this.NoOfPeople
              : null}
          </strong>
          {this.userDetailsConfig.enableNoOfPeopleField === true ? (
            <p className="sameFont">{this.props.getData().noOfPeople}</p>
          ) : null}

          <br />
        </div>
      );
    }
  };

  getDateTime = () => {
    if (
      this.state.response.data.previous_appointment_info !== undefined &&
      this.state.response.data.previous_appointment_info !== null
    ) {
      return (
        <div className="booking-summary-date">
          <p className="sameFont">
            {moment(
              this.state.response.data.previous_appointment_info
                .appointment_date,
              "MM-DD-YYYY"
            ).format("DD-MMM-YYYY")}{" "}
            &nbsp;
            {this.props
              .getData()
              .response.data.previous_appointment_info.appointment_time.substring(
                0,
                5
              )}
          </p>
        </div>
      );
    } else {
      return (
        <div className="booking-summary-date">
          <p className="sameFont">
            {this.props.getData().date !== null
              ? this.props.getData().date
              : null}
            &nbsp;{" "}
            {this.props.getData().time !== null
              ? this.props.getData().time
              : null}
          </p>
        </div>
      );
    }
  };

  getBranchAddress = () => {
    if (
      this.state.response.data.previous_appointment_info !== undefined &&
      this.state.response.data.previous_appointment_info !== null
    ) {
      return (
        <div className="booking-summary-date">
          <div className="top-text">
            <strong
              className="sameHeads sameTextColor"
              style={{ color: this.color.headsColor }}
            >
              {this.Where}
            </strong>
          </div>
          <p className="sameFont">
            {`${this.state.response.data.previous_appointment_info.branch_title} | ${this.state.response.data.previous_appointment_info.address}`}
          </p>
          <p className="sameFont">
            {this.props.getData().singleBranchDetails.length > 0
              ? this.props.getData().singleBranchDetails[0].ContactNo
              : this.props.getData().selectedBranchFromMap.ContactNo}
          </p>
        </div>
      );
    } else {
      return (
        <div className="booking-summary-date">
          <div className="top-text">
            <strong
              className="sameHeads sameTextColor"
              style={{ color: this.color.headsColor }}
            >
              {this.Where}
            </strong>
          </div>

          <p className="sameFont">
            {`${
              this.props.getData().singleBranchDetails.length > 0
                ? this.props.getData().singleBranchDetails[0].BranchTitle
                : this.props.getData().selectedBranchFromMap.BranchTitle
            } | ${
              this.props.getData().singleBranchDetails.length > 0
                ? this.props.getData().singleBranchDetails[0].Address
                : this.props.getData().selectedBranchFromMap.Address
            }`}
          </p>
          <p className="sameFont">
            {this.props.getData().singleBranchDetails.length > 0
              ? this.props.getData().singleBranchDetails[0].ContactNo
              : this.props.getData().selectedBranchFromMap.ContactNo}
          </p>
        </div>
      );
    }
  };

  getAppointmentNumber = () => {
    if (
      this.state.response.data.previous_appointment_info !== undefined &&
      this.state.response.data.previous_appointment_info !== null
    ) {
      return (
        <div className="booking-summary-date">
          <div className="booking-summary-details">
            <strong
              className="sameHeads sameTextColor"
              style={{ color: this.color.headsColor }}
            >
              {this.BookingRef}
            </strong>
          </div>
          <p
            className="sameFont"
            style={{ fontSize: "24px", fontWeight: "bold", color: "#000" }}
          >
            {
              this.state.response.data.previous_appointment_info
                .appointment_number
            }
          </p>
        </div>
      );
    } else if (this.state.response.data.issueAppointment !== undefined) {
      return (
        <div className="booking-summary-date">
          <div className="booking-summary-details">
            <strong
              className="sameHeads sameTextColor"
              style={{ color: this.color.headsColor }}
            >
              {this.BookingRef}
            </strong>
          </div>
          <p
            className="sameFont"
            style={{ fontSize: "24px", fontWeight: "bold" }}
          >
            {this.state.response.data.issueAppointment !== undefined
              ? this.state.response.data.issueAppointment.appointment_number
              : null}
          </p>
        </div>
      );
    }
  };

  getTicketNumber = () => {
    if (
      this.state.response.data.ticket_info !== undefined &&
      this.state.response.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-date">
          <div className="booking-summary-details">
            <p
              className="sameTextColor"
              style={{ fontSize: "30px", color: this.color.headsColor }}
            >
              {this.TicketNumber}
            </p>
          </div>
          <p
            className="sameFont sameTextColor "
            style={{ fontSize: "58px", fontWeight: "bold", color: "#000" }}
          >
            <strong
              className={
                this.state.isTicketCalled
                  ? "blink sameHeads sameTextColor"
                  : "sameHeads sameTextColor"
              }
              style={{
                position: "absolute",
                marginLeft: "-80px",
              }}
            >
              {this.state.response.data.ticket_info.ticket_no}
            </strong>
          </p>
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      );
    } else if (
      this.state.response.data !== undefined &&
      this.state.response.data !== null &&
      this.state.response.data !== "" &&
      this.props.getData().issueQrTicket === true
    ) {
      return (
        <div className="booking-summary-date">
          <div className="booking-summary-details">
            <p
              className="sameTextColor"
              style={{ fontSize: "30px", color: this.color.headsColor }}
            >
              {this.TicketNumber}
            </p>
          </div>
          <p
            className="sameFont "
            style={{ fontSize: "56px", fontWeight: "bold", color: "#000" }}
          >
            <strong
              className={
                this.state.isTicketCalled
                  ? "blink sameHeads sameTextColor"
                  : "sameHeads sameTextColor"
              }
              style={{
                position: "absolute",
                marginLeft: "-80px",
              }}
            >
              {this.state.response.data.ticket_number_f}
            </strong>
          </p>
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      );
    } else {
      return null;
    }
  };

  getTotalWaitingTime = (lang) => {
    if (
      this.state.response.data.ticket_info !== undefined &&
      this.state.response.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-wait">
          <p className="sameFont">
            {`${lang.EstimatedWaitTimeMessage} ${Math.floor(
              this.state.response.data.ticket_info.category_approx_waittime / 60
            )} ${lang.Minutes}`}
          </p>

          <br />
        </div>
      );
    } else if (
      this.state.response.data !== undefined &&
      this.state.response.data !== null &&
      this.state.response.data !== "" &&
      this.props.getData().issueQrTicket === true
    ) {
      let timestamp = this.state.response.data.category_approx_waittime;

      let waitTime = "";

      waitTime = handler.formatTimeStamp(timestamp, "minutes");
      return (
        <div className="booking-summary-date" style={{ alignItems: "center" }}>
          {this.state.response.IsTicketCalled === false ? (
            <div className="booking-summary-details">
              <strong
                className="sameHeads sameTextColor"
                style={{ color: this.color.headsColor }}
              >
                {this.WaitTime}
              </strong>
            </div>
          ) : null}

          <div>
            <p
              className="sameFont "
              style={{ whiteSpace: "pre-line", display: "block" }}
            >
              {`${
                this.state.response.IsTicketCalled === false
                  ? this.WaitTimeMsg
                  : ""
              } ${
                this.state.response.IsTicketCalled === false ? waitTime : ""
              }`}
            </p>
          </div>
          <br />
        </div>
      );
    } else {
      return null;
    }
  };

  getTicketIssuedDateTime = () => {
    if (
      this.state.response.data.ticket_info !== undefined &&
      this.state.response.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-wait">
          {/* <strong className="sameHeads sameTextColor" style={{ color: this.color.headsColor }}>
            {this.TicketIssuedOn}
          </strong> */}
          <p className="sameFont">
            {moment(this.state.response.data.ticket_info.issued_on).format(
              "DD-MMM-YYYY hh:mm A"
            )}
          </p>
          <br />
        </div>
      );
    } else if (
      this.state.response.data !== undefined &&
      this.state.response.data !== null &&
      this.state.response.data !== "" &&
      this.props.getData().issueQrTicket === true
    ) {
      return (
        <div className="booking-summary-date">
          {/* <div className="booking-summary-details">
            <strong className="sameHeads sameTextColor" style={{ color: this.color.headsColor }}>
              {this.TicketIssuedOn}
            </strong>
          </div> */}
          <p className="sameFont ">
            {/* {this.state.response.data.ticket_issue_time} */}
            {moment(this.state.response.data.ticket_issue_time).format(
              "DD-MMM-YYYY hh:mm A"
            )}
          </p>
          <br />
        </div>
      );
    } else {
      return null;
    }
  };

  getTicketsWaiting = (lang) => {
    if (
      this.state.response.data.ticket_info !== undefined &&
      this.state.response.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-wait">
          {/* <strong
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.TotalWaitingTickets}
          </strong> */}

          <p className="sameFont">
            {/* {this.state.response.data.ticket_info.ticket_in_wait} */}
            {`${lang.ThereArePeople} ${this.state.response.data.ticket_info.ticket_in_wait} ${lang.TicketInWait} `}
          </p>

          <br />
        </div>
      );
    } else if (
      this.state.response.data !== undefined &&
      this.state.response.data !== null &&
      this.state.response.data !== "" &&
      this.props.getData().issueQrTicket === true
    ) {
      return (
        <div className="booking-summary-date">
          <div className="booking-summary-details">
            <strong
              className="sameHeads sameTextColor"
              style={{ color: this.color.headsColor }}
            >
              {this.state.response.IsTicketCalled === false
                ? this.TotalWaitingTickets
                : ""}
            </strong>
          </div>
          <p className="sameFont ">
            {this.state.response.IsTicketCalled === false
              ? this.state.response.data.category_waiting_tickets
              : ""}
          </p>
          <br />
        </div>
      );
    } else {
      return null;
    }
  };

  getService = () => {
    if (
      this.state.response.data.previous_appointment_info !== undefined &&
      this.state.response.data.previous_appointment_info !== null
    ) {
      return (
        <div className="booking-summary-date">
          <strong
            className="sameHeads sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.state.response.data.previous_appointment_info
              .phone_service === ""
              ? null
              : this.For}{" "}
          </strong>
          <p className="sameFont">
            {this.state.response.data.previous_appointment_info
              .phone_service === ""
              ? null
              : this.state.response.data.previous_appointment_info
                  .phone_service}
          </p>
        </div>
      );
    } else {
      return (
        <div className="booking-summary-date">
          {/* <strong>For a: </strong> */}
          {this.props.getData().phoneServiceName !== null &&
          this.props.getData().phoneServiceName !== "" ? (
            <strong
              className="sameHeads"
              style={{ color: this.color.headsColor }}
            >
              {this.For}{" "}
            </strong>
          ) : null}
          <p className="sameFont">
            {this.props.getData().phoneServiceName == null &&
            this.props.getData().phoneServiceName == ""
              ? null
              : this.props.getData().phoneServiceName}
          </p>
        </div>
      );
    }
  };

  renderTranslations = () => {
    let lang;
    if (localStorage.getItem("lang") === "es") {
      lang = window["localization"].es;
    } else if (localStorage.getItem("lang") === "ar") {
      lang = window["localization"].ar;
    } else if (localStorage.getItem("lang") === "en") {
      lang = window["localization"].en;
    } else if (localStorage.getItem("lang") === "ur") {
      lang = window["localization"].ur;
    } else {
      let defaultLang = this.defaultLanguage;
      lang = window["localization"][defaultLang];
    }

    this.cancelButtonText = lang.CancelAppointment;
    this.rescheduleButtonText = lang.Reschedule;
    this.Attention = lang.Attention;
    this.DoYouWantToRescheduleOrCancel = lang.DoYouWantToRescheduleOrCancel;
    this.For = lang.For;
    this.someThingWentWrong = lang.SomeThingWentWrong;
    this.error = lang.Error;
    this.AppointmentAlreadyCanceled = lang.AppointmentAlreadyCanceled;
    this.Ok = lang.Ok;
    this.AppointmentInfoNotValidToCancel = lang.AppointmentInfoNotValidToCancel;
    this.CantCancelApptTcktIssued = lang.CantCancelApptTcktIssued;
    this.AppointmentExpired = lang.AppointmentExpired;
    this.AlreadyServed = lang.AlreadyServed;
    this.AppointmentCanceledAutomatically = lang.ApptCanceledAutomatically;
    this.Yes = lang.Yes;
    this.No = lang.No;
    this.CancelTicketConfirmation = lang.CancelTicketConfirmation;
    this.TicketIssuedOn = lang.TicketIssuedTime;
    this.WaitTime = lang.WaitingTime;
    this.TotalWaitingTickets = lang.TicketInWait;
    this.UrlNotFound = lang.UrlNotFound;
    this.InternetConnectionError = lang.InternetConnectionError;
    this.Where = lang.AtThe;
    this.TicketNumber = lang.TicketNumber;
    this.BookingRef = lang.BookingRef;
    this.Name = lang.FirstNamePlaceholder;
    this.Email = lang.EmailAddressPlaceHolder;
    this.PhoneNumber = lang.PhoneNumberPlaceholder;
    this.NoOfPeople = lang.NoOfPeople;
    this.WaitTimeMsg = lang.EstimatedWaitTimeMessage;
    this.Greetings = lang.Greetings;
    this.ServerNotResponding = lang.ServerNotResponding;
    this.TicketNotFound = lang.TicketNotFound;
  };

  //API CALLS

  rescheduleOrCancelAppointment = async () => {
    swal(
      this.DoYouWantToRescheduleOrCancel,

      {
        icon: "warning",
        buttons: {
          reschedule: {
            text: this.rescheduleButtonText,
            value: "reschedule",
          },
          cancelAppointment: {
            text: this.cancelButtonText,
            value: "cancelAppointment",
            closeModal: false,
          },
        },
      }
    ).then(async (value) => {
      switch (value) {
        case "cancelAppointment":
          try {
            let response = await this.dataService.cancelAppointment(
              this.state.response.data.previous_appointment_info !== null
                ? this.state.response.data.previous_appointment_info
                    .appointment_number
                : this.state.response.data.issueAppointment.appointment_number,
              this.state.response.data.previous_appointment_info !== null
                ? this.state.response.data.previous_appointment_info.category_id
                : this.props.getData().categoryId,
              (this.enableCategorySelection === true ||
                this.enableCategorySelection === false) &&
                this.props.getData().singleBranchDetails.length === 0
                ? this.props.getData().selectedBranchFromMap.BranchID
                : this.props.getData().singleBranchDetails[0].BranchID,
              this.state.response.data.previous_appointment_info !== null
                ? this.state.response.data.previous_appointment_info.email_id
                : this.props.getData().emailAddress !== undefined
                ? this.props.getData().emailAddress
                : this.props.getData().phoneNumber
            );
            swal.close();

            if (
              response.data.error !== undefined &&
              response.data.error === true
            ) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok
              );
            } else {
              if (response.data.response.resp_status === 1) {
                localStorage.removeItem("confirmed");
                localStorage.removeItem("prevState");
                handler.redirect(window.location.href);
              } else if (response.data.response.resp_status === 6) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentAlreadyCanceled,
                  this.Ok
                );
              } else if (response.data.response.resp_status === -5) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentInfoNotValidToCancel,
                  this.Ok
                );
              } else if (response.data.response.resp_status === 2) {
                handler.showErrorMessage(
                  this.error,
                  this.CantCancelApptTcktIssued,
                  this.Ok
                );
              } else if (response.data.response.resp_status === 7) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentExpired,
                  this.Ok
                );
              } else if (response.data.response.resp_status === -2) {
                handler.showErrorMessage(
                  this.error,
                  this.AlreadyServed,
                  this.Ok
                );
              } else if (response.data.response.resp_status === -3) {
                handler.showErrorMessage(
                  this.error,
                  this.AppointmentCanceledAutomatically,
                  this.Ok
                );
              } else {
                handler.showErrorMessage(
                  this.error,
                  this.someThingWentWrong,
                  this.Ok
                );
              }
            }
          } catch (error) {
            if (error.message.includes("timeout")) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok
              );
            } else {
              handler.showErrorMessage(
                this.error,
                this.someThingWentWrong,
                this.Ok
              );
            }
          }
          break;

        case "reschedule":
          if (this.runApp.toLowerCase() === "samsung") {
            this.props.getStepCount(2, true, true);
          } else if (this.enableCategorySelection === false) {
            this.props.getStepCount(1, true, true);
          } else if (this.enableCategorySelection === true) {
            this.props.getStepCount(2, true, true);
          }

          break;

        default:
      }
    });
  };

  cancelTicket = async () => {
    swal(
      this.CancelTicketConfirmation,

      {
        icon: "warning",
        buttons: {
          yes: {
            text: this.Yes,
            value: "yes",
            closeModal: false,
          },
          no: {
            text: this.No,
            value: "no",
          },
        },
      }
    ).then(async (value) => {
      switch (value) {
        case "yes":
          let phoneNumber =
            this.props.getData().phoneNumber !== undefined
              ? this.props.getData().phoneNumber.replace("+", "%2b")
              : "-";
          let email =
            this.props.getData().emailAddress !== undefined &&
            this.props.getData().emailAddress !== null
              ? this.props.getData().emailAddress
              : phoneNumber;

          let ticketId;
          let ticketNumber;
          let sqn;

          if (
            this.state.response.data.ticket_info !== undefined &&
            this.state.response.data.ticket_info !== null
          ) {
            ticketId = this.state.response.data.ticket_info.ticket_id;
            ticketNumber = this.state.response.data.ticket_info.ticket_no;
            sqn = this.state.response.data.ticket_info.categoryid;
          } else {
            ticketId = "-";
            ticketNumber = "-";
            sqn = "-";
          }
          let branchId =
            this.props.getData().singleBranchDetails.length > 0
              ? this.props.getData().singleBranchDetails[0].BranchID
              : this.props.getData().selectedBranchFromMap.BranchID;

          let language =
            localStorage.getItem("lang") === "es"
              ? "Sp"
              : localStorage.getItem("lang");

          try {
            let cancelTicketResponse = await this.dataService.cancelTicket(
              email,
              ticketId,
              branchId,
              language,
              ticketNumber,
              sqn,
              phoneNumber
            );

            if (
              cancelTicketResponse.data.error !== undefined &&
              cancelTicketResponse.data.error
            ) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok
              );
            } else {
              if (
                cancelTicketResponse.data.resp_message === "Ticket cancelled"
              ) {
                swal.close();
                localStorage.removeItem("confirmed");
                localStorage.removeItem("prevState");
                handler.redirect(window.location.href);
              } else if (
                cancelTicketResponse.data.resp_message === "Ticket not found" ||
                cancelTicketResponse.data.resp_message ===
                  "Operation not permitted"
              ) {
                handler.showErrorMessage(
                  this.error,
                  this.TicketNotFound,
                  this.Ok
                );
                localStorage.removeItem("confirmed");
                localStorage.removeItem("prevState");
                handler.redirect(window.location.href);
              } else {
                handler.showErrorMessage(
                  this.error,
                  this.someThingWentWrong,
                  this.Ok
                );
              }
            }
          } catch (error) {
            if (error.message.includes("404")) {
              handler.showErrorMessage(this.error, this.UrlNotFound, this.Ok);
            } else if (error.message.includes("Network Error")) {
              handler.showErrorMessage(
                this.error,
                this.InternetConnectionError,
                this.Ok
              );
            } else if (error.message.includes("timeout")) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok
              );
            }
          }

          break;

        case "no":
          break;

        default:
      }
    });
  };

  cancelQrTicket = async () => {
    swal(
      this.CancelTicketConfirmation,

      {
        icon: "warning",
        buttons: {
          yes: {
            text: this.Yes,
            value: "yes",
            closeModal: false,
          },
          no: {
            text: this.No,
            value: "no",
          },
        },
      }
    ).then(async (value) => {
      switch (value) {
        case "yes":
          let branchCode = queryString.parse(window.location.search).branchCode;
          let branchId = queryString.parse(window.location.search).branchid;
          let ticketId = this.state.response.data.ticket_id;
          try {
            let cancelTicketResponse = await this.dataService.cancelQrTicket(
              branchId,
              branchCode,
              ticketId
            );
            if (
              cancelTicketResponse.data.error !== undefined &&
              cancelTicketResponse.data.error
            ) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok
              );
            } else {
              let parsedResponse = JSON.parse(
                JSON.parse(JSON.stringify(cancelTicketResponse.data))
              );
              console.log(parsedResponse[0].status);
              if (parsedResponse[0].status === "success") {
                swal.close();
                localStorage.removeItem("confirmed");
                localStorage.removeItem("prevState");
                handler.redirect(window.location.href);
              }
            }
          } catch (error) {
            if (error.message.includes("404")) {
              handler.showErrorMessage(this.error, this.UrlNotFound, this.Ok);
            } else if (error.message.includes("Network Error")) {
              handler.showErrorMessage(
                this.error,
                this.InternetConnectionError,
                this.Ok
              );
            } else if (error.message.includes("timeout")) {
              handler.showErrorMessage(
                this.error,
                this.ServerNotResponding,
                this.Ok
              );
            }
            console.log(error.message);
          }

          break;

        case "no":
          break;

        default:
      }
    });
  };

  getTicketStatus = async () => {
    let ticketId;
    let ticketNumber;
    let branchId;
    let categoryId = this.props.getData().categoryId;
    if (
      this.props.getData().issueQrTicket &&
      (this.state.response.data !== undefined ||
        this.state.response.data !== null)
    ) {
      ticketId = this.state.response.data.ticket_id;
      ticketNumber = this.state.response.data.ticket_number_f1;
      branchId = queryString.parse(window.location.search).branchid;
    } else if (
      this.props.getData().issueTicket &&
      this.state.response.data.ticket_info !== undefined &&
      this.state.response.data.ticket_info !== null
    ) {
      ticketId = this.state.response.data.ticket_info.ticket_id;
      ticketNumber = this.state.response.data.ticket_info.ticket_no;
      branchId =
        this.props.getData().singleBranchDetails.length > 0
          ? this.props.getData().singleBranchDetails[0].BranchID
          : this.props.getData().selectedBranchFromMap.BranchID;
    }
    try {
      let response = await this.dataService.getTicketStatus(
        branchId,
        ticketId,
        ticketNumber,
        categoryId
      );
      console.log("TICKET STATUS RESPONSE: ", response);
      if (response.data.error !== undefined && response.data.error) {
        handler.showErrorMessage(this.error, this.ServerNotResponding, this.Ok);
      } else {
        if (response.data.resp_status === 1) {
          if (
            this.props.getData().issueTicket &&
            this.state.response.data.ticket_info !== undefined &&
            this.state.response.data.ticket_info !== null
          ) {
            let stateResp = { ...this.state.response };
            stateResp["data"]["ticket_info"][
              "category_approx_waittime"
            ] = response.data.est_wait_time.toString();
            stateResp["data"]["ticket_info"]["ticket_in_wait"] =
              response.data.position_in_queue <= 0
                ? 0
                : parseInt(response.data.position_in_queue);
            this.setState({ response: stateResp });
            let prevState = JSON.parse(localStorage.getItem("prevState"));
            prevState["response"] = stateResp;
            localStorage.setItem("prevState", JSON.stringify(prevState));
          } else if (
            this.props.getData().issueQrTicket &&
            (this.state.response.data !== undefined ||
              this.state.response.data !== null)
          ) {
            let stateResp = { ...this.state.response };
            stateResp["data"][
              "category_approx_waittime"
            ] = response.data.actual_wait_time.toString();
            stateResp["data"]["category_waiting_tickets"] =
              parseInt(response.data.position_in_queue) <= 0
                ? 0
                : parseInt(response.data.position_in_queue);
            this.setState({ response: stateResp });
            let prevState = JSON.parse(localStorage.getItem("prevState"));
            prevState["response"] = stateResp;
            localStorage.setItem("prevState", JSON.stringify(prevState));
          }
        } else if (response.data.resp_status === 2) {
          this.setState({ isTicketCalled: true });
          handler.notify();
        } else if (response.data.resp_status === 3) {
          localStorage.clear();
          handler.showErrorMessage(this.error, this.TicketNotFound, this.Ok);
          setTimeout(() => {
            localStorage.clear();
            handler.redirect(window.location.href);
          }, this.popupExpiry);
        }
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        handler.showErrorMessage(this.error, this.ServerNotResponding, this.Ok);
      } else {
        handler.showErrorMessage(this.error, this.someThingWentWrong, this.Ok);
        console.log(error.message);
      }
    }
  };

  render() {
    this.renderTranslations();
    const queryStringColor = queryString.parse(window.location.search);
    var theme = queryStringColor.theme;

    let emailAddress = this.props.getData().emailAddress;
    let appointmentNumber;
    let appointmentDate;

    if (
      this.state.response.data.previous_appointment_info !== undefined &&
      this.state.response.data.previous_appointment_info !== null
    ) {
      appointmentNumber = this.state.response.data.previous_appointment_info
        .appointment_number;

      appointmentDate = moment(
        this.state.response.data.previous_appointment_info.appointment_date,
        "MM-DD-YYYY"
      ).format("YYYY-MM-DD");
    } else if (
      this.state.response.data.issueAppointment !== undefined &&
      this.state.response.data.issueAppointment !== null
    ) {
      {
        appointmentNumber = this.state.response.data.issueAppointment
          .appointment_number;

        appointmentDate = moment(
          this.props.getData().date,
          "DD-MMM-YYYY"
        ).format("YYYY-MM-DD");
      }
    }

    let appointmentBranchId =
      this.state.response.data.previous_appointment_info !== undefined &&
      this.state.response.data.previous_appointment_info !== null
        ? this.state.response.data.previous_appointment_info.branch_id
        : this.props.getData().singleBranchDetails.length > 0
        ? this.props.getData().singleBranchDetails[0].BranchID
        : this.props.getData().selectedBranchFromMap !== null
        ? this.props.getData().selectedBranchFromMap.BranchID
        : null;
    let lang;
    if (localStorage.getItem("lang") === "es") {
      lang = window["localization"].es;
    } else if (localStorage.getItem("lang") === "ar") {
      lang = window["localization"].ar;
    } else if (localStorage.getItem("lang") === "en") {
      lang = window["localization"].en;
    } else if (localStorage.getItem("lang") === "ur") {
      lang = window["localization"].ur;
    } else {
      let defaultLang = this.defaultLanguage;
      lang = window["localization"][defaultLang];
    }

    return (
      <div className="sl__modal-inner">
        {/* <h1>{this.state.randomNumber}</h1> */}
        <div className="sl__modal--content">
          {this.props.getData().issueTicket ||
          this.props.getData().issueQrTicket ? (
            <div>
              <RefreshButton
                onClick={this.getTicketStatus}
                color={this.color.buttonsColor}
              />
            </div>
          ) : null}

          {(this.showGreetings === true &&
            this.props.getData().issueTicket === true) ||
          this.props.getData().issueQrTicket === true
            ? this.getGreetings()
            : null}
          <h2
            className="sameTextColor"
            style={{ color: this.color.headsColor }}
          >
            {this.props.getData().issueTicket === true ||
            this.props.getData().issueQrTicket === true
              ? lang.IssueTicketConfirmedMessage
              : lang.ThanksForAppointment}
          </h2>

          <div className="booking-summary-subject ">
            {this.getTicketsWaiting(lang)}
          </div>

          <div className="booking-summary-address ">
            {this.getEstimatedWaitTimeMessage()}
          </div>

          <div className="booking-summary-subject ">
            {this.getTotalWaitingTime(lang)}
          </div>

          <div className="booking-final-container">
            <div className="booking-summary-confirmation">
              {this.props.getData().date === null &&
              this.props.getData().time === null ? null : (
                <strong className="top-text">
                  <strong
                    className="sameHeads sameTextColor"
                    style={{ color: this.color.headsColor }}
                  >
                    {lang.SeeYouOn}
                  </strong>
                </strong>
              )}
              {this.props.getData().issueTicket === true ||
              this.props.getData().issueQrTicket === true ? (
                <div style={{ width: "100%" }}>
                  <Journey
                    position={
                      this.props.getData().issueTicket
                        ? this.state.response.data.ticket_info.ticket_in_wait
                        : this.state.response.data.category_waiting_tickets
                    }
                  ></Journey>
                </div>
              ) : null}

              {/* DATE TIME FOR APPOINTMENT FLOW */}
              <div className="booking-summary-address ">
                {this.getDateTime()}
              </div>

              <div className="booking-summary-bookingref">
                {this.getTicketNumber()}
              </div>

              <div className="booking-summary-address ">
                {this.getTicketIssuedDateTime()}
              </div>

              <div className="booking-summary-address ">
                {this.props.getData().issueQrTicket === true
                  ? this.getUserDetails()
                  : null}
              </div>

              <div className="booking-summary-subject ">
                {this.runApp === "samsung" ? this.getService() : null}
              </div>

              {this.props.getData().issueTicket === false &&
              this.props.getData().issueQrTicket === false ? (
                <div className="booking-summary-address ">
                  {this.getBranchAddress()}
                </div>
              ) : null}

              {this.props.getData().issueQrTicket === false &&
              this.props.getData().issueTicket === false ? (
                <div className="location-ic">
                  <a
                    target="_blank"
                    href={`${this.URL.mapUrl}${this.state.branchTitle},${this.state.branchAddress}`}
                  >
                    <img
                      src={theme === "dark" ? LocationDarkImg : LocationImg}
                      style={{ width: "2%" }}
                    ></img>
                  </a>
                </div>
              ) : null}

              <div className="booking-summary-bookingref">
                {this.getAppointmentNumber()}
              </div>

              {this.props.getData().issueQrTicket === false &&
              this.props.getData().issueTicket === false ? (
                <div
                  className="img-btns"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    width: "100%",
                    margin: "0 auto",
                  }}
                >
                  <div
                    className="calender-ic"
                    onClick={this.rescheduleOrCancelAppointment}
                  >
                    <img src={CalendarImg} style={{ width: "20%" }}></img>
                    <span
                      className="img-btn-link sameTextColor"
                      style={{
                        paddingLeft: "15px",
                        fontSize: "16px",
                        fontWeight: "bold",

                        color: this.color.headsColor,
                      }}
                    >
                      {lang.ModifyOrCancel}
                    </span>
                  </div>

                  <div className="calender-ic">
                    <a
                      href={`${this.URL.icsFileUrl}${emailAddress}_${appointmentNumber}_${appointmentDate}_${appointmentBranchId}.ics`}
                      target="_blank"
                      download
                      className="ics-lnk"
                    >
                      <img
                        src={CalendarImgBlack}
                        style={{ width: "20%" }}
                      ></img>
                      <span
                        className="img-btn-link sameTextColor"
                        style={{
                          paddingLeft: "15px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: this.color.headsColor,
                        }}
                      >
                        {lang.AddToCalendar}
                      </span>
                    </a>
                  </div>
                </div>
              ) : null}

              {this.props.getData().issueQrTicket ||
              this.props.getData().issueTicket ? (
                <div style={{ width: "100%" }}>
                  {this.color.enableWhatsappButton ? (
                    <div>
                      <IconButton
                        icon={
                          process.env.PUBLIC_URL +
                          `/images/${this.icons.whatsapp}`
                        }
                        onClick={this.state.whatsappUrl}
                        backgroundColor={this.color.iconBtns.backgroundColor}
                        fontColor={this.color.iconBtns.fontColor}
                        borderColor={this.color.iconBtns.borderColor}
                        text={lang.Whatsapp}
                        disabled={this.state.isTicketCalled}
                        disabledColor={this.color.iconBtns.disabledColor}
                      />
                      <br />
                    </div>
                  ) : null}

                  <DangerButton
                    text={lang.ModifyOrCancelTicket}
                    color={this.color.cancelTicketBtn}
                    onClick={
                      this.props.getData().issueQrTicket
                        ? this.cancelQrTicket
                        : this.cancelTicket
                    }
                    disabled={this.state.isTicketCalled}
                  />
                </div>
              ) : null}

              <br />
              {this.runApp.toLowerCase() === "samsung" ? <Preparation /> : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ConfirmedAppointment);
